module.exports = __webpack_public_path__ + "static/img/contacts.963da22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contacts.png
// module id = ZzYu
// module chunks = 5